import * as yup from 'yup'

export const createVacancySchema = yup.object().shape({
    name: yup.string().required('Укажите название вакансии'),
    description: yup.string().required('Укажите описание вакансии'),
    salary: yup.string().required('Укажите запрлатную вилку'),
    preview: yup.mixed()
        .test({
            message: 'Допустимые форматы .jpg, .jpeg, .png',
            test: (file: any, context) => {
                if (!file?.length) return true
                const isValid = typeof file === 'string' || ['image/png', 'image/jpg', 'image/jpeg'].includes(file?.type);
                if (!isValid) context?.createError();
                return isValid;
            }
        })
        .test({
            message: `Максимальный размер файла 4МБ`,
            test: (file: any) => {
                if (!file?.length) return true
                const isValid = typeof file === 'string' || file?.size < (4 * 1024 * 1024);
                return isValid;
            }
        })
        .optional()
})

export const updateVacancySchema = yup.object().shape({
    name: yup.string().required('Укажите название вакансии'),
    description: yup.string().required('Укажите описание вакансии'),
    salary: yup.string().required('Укажите запрлатную вилку'),
    preview: yup.mixed()
        .test({
            message: 'Допустимые форматы .jpg, .jpeg, .png',
            test: (file: any, context) => {
                if (!file?.length) return true
                const isValid = typeof file === 'string' || ['image/png', 'image/jpg', 'image/jpeg'].includes(file?.type);
                if (!isValid) context?.createError();
                return isValid;
            }
        })
        .test({
            message: `Максимальный размер файла 4МБ`,
            test: (file: any) => {
                if (!file?.length) return true
                const isValid = typeof file === 'string' || file?.size < (4 * 1024 * 1024);
                return isValid;
            }
        })
        .optional()
})